import { createFileRoute, notFound, redirect } from '@tanstack/react-router';
import { domAnimation, LazyMotion } from 'motion/react';

import { ErrorNotFound } from '#features/error/components/ErrorNotFound';
import { defaultLocale, isLocaleValid } from '#features/i18n';
import { getPathnamePrefix } from '#features/i18n/utils/getPathnamePrefix';
import { parseLocaleParam } from '#features/i18n/utils/localeParam';
import { MainLayout } from '#features/layout/components/MainLayout';
import { envConfig } from '#constants/envConfig';

export const Route = createFileRoute('/{-$locale}')({
  // Не язык в первом слове адреса - этот вариант не подходит (см. parseLocaleParam).
  params: { parse: parseLocaleParam },
  // С шапкой и подвалом, как на корневом маршруте: локализованный несуществующий адрес
  // (`/ru/nope`) разбирается здесь, и голый экран ошибки выпадал бы из сайта.
  notFoundComponent: () => (
    <LazyMotion features={domAnimation}>
      <MainLayout plain>
        <ErrorNotFound />
      </MainLayout>
    </LazyMotion>
  ),
  beforeLoad: async ({ params, search, context }) => {
    const locale = context.i18n.locale;
    const paramLocale = params.locale ?? defaultLocale;

    if (!isLocaleValid(paramLocale)) {
      throw notFound({ routeId: '__root__' });
    }

    if (locale && locale !== paramLocale) {
      throw redirect({
        to: '.',
        params: { ...params, locale: getPathnamePrefix(locale) },
        search,
        // В приложении каталог уже в памяти и сервера нет – перезагрузка страницы ничего не даёт,
        // а на холодном старте по ссылке перезагрузки складывались в цикл.
        reloadDocument: !envConfig.IS_NATIVE,
      });
    }
  },
});
